// AGZDModal.styles.ts
import styled from "styled-components";

export const ModalWrapper = styled.div`
  position: relative;
  margin: 0 20px;
  padding: 0px;
  @media (max-width: 768px) {
    padding-bottom: 72px;
  }
  @media (min-width: 768px) {
    margin: 0;
    padding-top: 2rem;
  }
  /* Add other wrapper styles like width, etc. if needed */
`;

export const TopImageWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  position:absolute;
  top:16px;
  right:16px;
  @media (max-width: 768px) {
        top: -8px;
        right: -4px;
  }
`;

export const MainTitleWrapper = styled.div`
  display: inline-block;
  @media (min-width: 768px) {
    margin: 0rem 1rem 1rem 2rem;
  }
`;

export const MainTitle = styled.div`
  width: 100%;
  margin-top: 0px;
  color: #0a0a0a;
  font-family: "Euclid Circular B";
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 28px;
  text-align: center;
`;
export const HighlightTitle = styled.div`
  text-align: center;
  font-family: "Euclid Circular B";
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 32px;
  letter-spacing: -0.1px;
  background: linear-gradient(90deg, #e64980 27.73%, #5b51f4 83.55%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;

export const ContentCard = styled.div`
  display: flex;
  padding: 0px 0px;
  flex-direction: column;
  gap: 16px;
  align-self: stretch;
  @media (max-width: 768px) {
    padding: 12px 12px;
    margin-top: 12px;
    border-radius: 16px;
    border: 1px solid var(--line-primary-n-200, #e7e7f0);
    background: rgba(255, 255, 255, 0.9);
    box-shadow: 0 4px 32px 0 rgba(0, 0, 0, 0.12);
  }
  @media (min-width: 768px) {
    margin: 0 0 0 2rem;
  }
`;

export const HighlightSubtitle = styled.div`
  text-align: center;
  font-family: "Euclid Circular B";
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 32px;
  letter-spacing: -0.1px;
  background: linear-gradient(90deg, #e64980 27.73%, #5b51f4 83.55%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;

export const InfoBanner = styled.div`
  display: flex;
  padding: 8px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  border-radius: 8px;
  background: rgba(239, 233, 251, 0.5);

  @media (min-width: 768px) {
    background: none;
    padding: 0;
    align-items: left;
    text-align: left;
    margin: 0 2rem 0 0;
  }
`;

export const InfoBannerText = styled.div`
  color: var(--Neutral-N500, #36354c);
  text-align: center;
  font-family: "Euclid Circular B";
  font-size: 14px;
  font-style: normal;
  line-height: 18px;

  span {
    font-weight: 600;
  }
  @media (min-width: 768px) {
    background: none;
    padding: 0;
    align-items: left;
    text-align: left;
    margin-bottom: 8px;
  }
`;

export const BenefitsList = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  @media (min-width: 768px) {
    margin: 0 2rem 0 0;
  }
`;

export const BenefitItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 4px;
  align-self: stretch;
  width: 100%;
`;

export const BenefitText = styled.div`
  color: var(--Neutral-N500, #36354c);
  font-family: "Euclid Circular B";
  font-size: 14px;
  font-style: normal;
  line-height: 20px;

  span {
    font-weight: 700;
  }
`;
export const ServiceCenterSeparator = styled.div`
  width: 100%;
  height: 1px;
  border-top: 1px dashed #e7e7f0;
  margin: 0px 0px;
  @media (min-width: 768px) {
    width: 96%;
  }
`;
export const ServiceCenterScroller = styled.div`
  overflow-x: scroll;
  scrollbar-width: none; /* For Firefox */
  -ms-overflow-style: none; /* For IE and Edge */

  &::-webkit-scrollbar {
    display: none; /* For Chrome, Safari, and Opera */
  }
  @media (min-width: 768px) {
    margin-bottom: 16px;
  }
`;

export const ServiceCenterList = styled.div`
  display: flex;
  flex-direction: row;
  width: max-content;
  height: 100%;
  gap: 12px;
`;

export const ServiceCenterCardWrapper = styled.div`
  width: 240px;
  border: 1px solid #e7e7f0;
  border-radius: 12px;
  display: flex;
  padding: 16px;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
  align-self: stretch;
`;

export const ServiceCenterInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  flex-shrink: 0;
`;

export const ServiceCenterTitle = styled.div`
  color: var(--text-primary-n-600, #040222);
  font-family: "Euclid Circular B";
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 240px;
`;

export const ServiceCenterSubText = styled.div`
  color: var(--text-secondary-n-400, #5b5675);
  font-family: "Euclid Circular B";
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  display: flex;
  align-items: center;
`;

export const ServiceCenterLocationText = styled.div`
  width: 240px;
  color: var(--text-secondary-n-400, #5b5675);
  font-family: "Euclid Circular B";
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const ExploreLink = styled.div`
  display:none;
  color: var(--Neutral-N500, #36354c);
  text-align: center;
  font-family: "Euclid Circular B";
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
  text-decoration-line: underline;
  text-underline-offset: 4px;
  cursor: pointer;
  margin: 12px 2rem 0;
  @media (min-width: 768px) {
    transform: translateX(-1rem);
    margin: 12px 2rem;
  }
`;

export const WarningBox = styled.div`
  display: flex;
  padding: 10px 14px 10px 12px;
  justify-content: flex-start;
  align-items: center;
  gap: 9px;
  border-radius: 8px;
  background: #fff7e5;
  margin-top: 12px;
  @media (max-width: 768px) {
    position:fixed;
    bottom:124px;
  }
  @media (min-width: 768px) {
    margin: 4px 2rem 16px;
  }
`;

export const WarningText = styled.div`
  color: var(--Text-Primary, #040222);
  font-family: "Euclid Circular B";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;

  span {
    font-weight: 500;
  }
`;

export const MainTitleWrapperDesktop = styled.span`
  font-family: "Euclid Circular B", sans-serif;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 28px;
  letter-spacing: -0.1px;
`;

// A specific style for the regular text part.
export const RegularText = styled(MainTitleWrapperDesktop)`
  color: var(--text-primary-n-600, #040222);
`;

// Extends the base BenefitText and adds the unique gradient styles.
export const GradientText = styled(MainTitleWrapperDesktop)`
  background: linear-gradient(90deg, #5b51f4 27.73%, #e64980 39.54%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;

  font-family: "Euclid Circular B";
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 28px;
  letter-spacing: -0.1px;
`;
